<mat-card class="mat-elevation-z8">
    <mat-card-header>
        <div mat-card-avatar class="example-header-image"></div>
        <mat-card-title>Printer</mat-card-title>
        <mat-card-subtitle>State</mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
        <p>{{printerState}}</p>
    </mat-card-content>
    <mat-card-actions>
        <button mat-button (click)="getState();">Update</button>
        <button mat-button (click)="findPrinter();">Find Printer</button>
    </mat-card-actions>
</mat-card>